<template>
<div>
    <div class="about-us">
      <el-container class="d-flex-column">
        <el-row :gutter="24">
          <el-col :span="12">&nbsp;</el-col>
           <el-col :span="12" >
                    <h2>Come join us</h2>
                    <p>Want to be part of maren solutions, please click on the below Button to drop your resume </p>
                    <div class="btn-bg">
                        <el-button size="large" class="drop-res" round type="warning" @click="dialogFormVisible = true">Drop your resume here <i class="pull-right icon-sort-arrow-right"></i></el-button>
                    </div>                    
                </el-col>
        </el-row>
      </el-container>
    </div>
    <el-container class="d-flex-column">
        <!--<hr />
        <div class="core-values">
            <h2>Our Core Values</h2>
            <el-row :gutter="30" class="careers-grid">
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg">
                        <h4>Continue to grow</h4>
                        <p>We keep learning, teaching, and growing individually, as a company and as a community.</p>                    
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg bg-white">
                        <h4>Lead with passion</h4>
                        <p>We love what we do and we do what we love. We are driven, take ownership for our work, and hold each other responsible.</p>                    
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg">
                        <h4>Bring good vibes</h4>
                        <p>We are positive, respectful team players. We build each other up, and are always ready to go the extra mile to help one another. </p>                    
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <hr />-->
    </el-container>
    <!--<div class="come-join">
        <el-container>
            <!--<el-row :gutter="24" class="p-t80">
                <el-col :span="18" :offset="6">
                    <h2>Come join us</h2>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. </p>
                    <div class="btn-bg">
                        <el-button size="large" class="drop-res" round type="warning" @click="dialogFormVisible = true">Drop your resume here <i class="pull-right icon-sort-arrow-right"></i></el-button>
                    </div>                    
                </el-col>
            </el-row>
        </el-container>
    </div>-->
    <el-dialog title="Walk us through your profile" :visible.sync="dialogFormVisible" width="60%">
                <el-form :model="form">
                    <el-row :gutter="50">
                        <el-col :span="12">
                            <el-form-item label="First name">
                                <el-input v-model="form.name" class="form-control"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Last name">
                                <el-input v-model="form.lastname" class="form-control"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Phone number">
                                <el-input v-model="form.number" class="form-control"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Alternative phone number">
                                <el-input v-model="form.alternativenumber" class="form-control"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Email">
                                <el-input v-model="form.email" class="form-control"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Attachment">
                                <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/">
                                <i class="icon-attachment"></i>
                                <span class="el-upload__text">Attach your resume</span>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="warning" round size="large" @click="onSubmit">Submit</el-button>
                </span>
            </el-dialog>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
          dialogFormVisible: false,
          form: {
            name: '',
            lastname:'',
            number:'',
            alternativenumber:'',
            email:''

            }
        }
      },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
        onSubmit() {
            console.log('submit!');
        }
      },
        mounted() {
          this.toggleBodyClass('addClass', 'careers');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'careers');
        }
    };
</script>


// WEBPACK FOOTER //
// Careers.vue